import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { ContactPersonEndpoint } from '@dato-proxy/endpoints/contactperson.endpoint';
import { ContactPerson } from '@dato-proxy/entities/contactperson.entity';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { Component } from '@angular/core';
import { EnumSystemTypes } from '@dato-proxy/enums';
import { Globals } from 'projects/dato/_globals';

class State extends BaseState {
    IsReadOnlyIsDefault: boolean = false;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-contact-person',
    templateUrl: './contact-person.component.html',
    styleUrls: ['./contact-person.component.scss']
})
export class ContactPersonComponent extends BasePageCRUDComponent<ContactPerson, State, ContactPersonEndpoint>
{
    constructor(A: ServiceBagService,
        ContactPersonEndpoint: ContactPersonEndpoint) {
        super(A, 'ContactPersonComponent', ContactPerson, State, ContactPersonEndpoint);
    }
    public IsLandlord() { return Globals.SystemOption && Globals.SystemOption.SystemType === EnumSystemTypes.Landlord; }

    override OnIsDirtyDisabled() { return true };

    override OnEntityNew() {
        this.Entity.IsActive = true;
    }

    override OnEntitySaved() {
        this.ClosePage();
    }

    override OnEntityLoaded() {
        if (this.Entity.IsDefault) this.State.IsReadOnlyIsDefault = true;
    }
}
